// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__PQJp7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2eKcr"};